import { render, staticRenderFns } from "./Disclaimer.vue?vue&type=template&id=fc3a2558&scoped=true&"
var script = {}
import style0 from "./Disclaimer.vue?vue&type=style&index=0&id=fc3a2558&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3a2558",
  null
  
)

export default component.exports